export default __webpack_public_path__ + "static/media/svg-6.d29cf8a7.svg";